import { defineComponent, onMounted, toRef } from 'vue';
import { ICustomSkeleton } from './ICustomSkeleton';
import type { PropType } from 'vue';
import { SkeletonCB } from './SkeletonCB';

export default defineComponent({
	props: {
		active: {
			type: Boolean,
			required: true,
		},
		background: {
			type: String as PropType<'Light' | 'Dark'>,
			default: 'Light',
			required: false,
		},
		custom: {
			type: Object as PropType<ICustomSkeleton>,
			required: false,
		},
	},
	setup: (props) => {
		const component = new SkeletonCB(toRef(props, 'active'), props.background, props.custom);
		onMounted(component.mounted.bind(component));
		return {
			active: component.active,
			inactive: component.inactive,
			lightBackground: component.lightBackground,
			darkBackground: component.darkBackground,
			skeletonRef: component.skeletonRef
		}
	},
});
